"use strict";var e=require("styled-components").css`
    display: grid;
    grid-template-columns: 48px 1fr;
    grid-column-gap: 8px;
`;module.exports=e;
//# sourceMappingURL=styles.js.map
